/*
     Title: Product Parts API
     Description: Product Parts API
     Author: Iqbal Hossain
     Date: 09-January-2022
     Modified: 09-January-2022
*/

export const PRODUCT_PARTS_API = {
  root: '/api/product-parts',
  fetch_all: 'api/product-parts/fetch-all',
  fetch_by_query: `/api/product-parts/fetch-by-query`,
  fetch_by_id: `/api/product-parts/fetch-by-id`,
  add: `/api/product-parts/add`,
  update: `/api/product-parts/update`,
  delete: `/api/product-parts/delete`,
  delete_by_range: `/api/product-parts/delete-range`
};
